export const consentTexts = {
  header: {
    id: 'candidateForm.consent.header',
    defaultMessage: 'Consent form'
  },
  title: {
    id: 'candidateForm.consent.title',
    defaultMessage: 'Some quick housekeeping...'
  },
  text: {
    id: 'candidateForm.consent.text',
    defaultMessage: `
      I authorize {customer} to contact my provided references to conduct a reference check. I have 
      obtained consent directly from all provided references to 1) share all provided personal information 
      with {customer}, and 2) contact my references via email and SMS text message to initiate the reference 
      check.{breakingLine}{breakingLine}I authorize my references to release information regarding me, whether 
      the information is positive or negative. I understand that my potential employment with {customer} may be 
      subject to information provided by my references.{breakingLine}{breakingLine}
    `
  },
  textBold: {
    id: 'candidateForm.consent.text.bold',
    defaultMessage: `
      I voluntarily release all my references, {customer}, and KodiakHR from any liability arising from 
      information obtained from my references.
    `
  },
  checkbox: {
    id: 'candidateForm.checkbox',
    defaultMessage: 'I agree to the above and to KodiakHR’s {link}.'
  },
  link: {
    id: 'candidateForm.checkboxLink',
    defaultMessage: 'Terms of Service'
  }
};
